// extracted by mini-css-extract-plugin
export default {"campaignlistuploader":"styles__campaignlistuploader___f247r"};